import axios from 'axios'
import { DEFAULT_TEXT_LIMITS, DEFAULT_PLATFORM_LABELS } from '@/constants/messageLimits'

let adminBaseApiUrl = 'https://lumen-admin.beneat.co'
if (window.location.hostname === 'localhost') {
  adminBaseApiUrl = 'https://api-admin.beneat-test.com'
}

const state = {
  redirectUrl: '',
  shift_work_types: [],
  adminBaseApiUrl: adminBaseApiUrl,
  // Seeded with the fallback copy so the composer's counter works from the first keystroke even if
  // GET /message-limits is slow or never lands. The server value always wins once it arrives.
  messageLimits: DEFAULT_TEXT_LIMITS,
  messageLimitLabels: DEFAULT_PLATFORM_LABELS
}

const actions = {
  fetchShiftWorkTypes: async ({ commit }) => {
    try {
      const { data } = await axios.get('/shift-work-types')
      commit('SET_SHIFT_WORK_TYPES', data.shift_work_types)
    } catch (err) {
      console.error('Error: ' + err.message)
    }
  },
  fetchMessageLimits: async ({ commit }) => {
    try {
      const { data } = await axios.get('/message-limits')
      commit('SET_MESSAGE_LIMITS', data)
    } catch (err) {
      // the fallback copy stays in place — the composer must never depend on this having resolved
      console.error('Error: ' + err.message)
    }
  }
}

const mutations = {
  SET_REDIRECT_URL: (state, url) => {
    state.redirectUrl = url
  },
  SET_SHIFT_WORK_TYPES: (state, types) => {
    state.shift_work_types = types
  },
  SET_MESSAGE_LIMITS: (state, payload) => {
    if (!payload) return
    if (payload.limits) {
      // Drift guard: developers only. The admin can do nothing about a mismatch, so there is no
      // user-facing surface for it. The server value always wins.
      const keys = Object.keys(Object.assign({}, DEFAULT_TEXT_LIMITS, payload.limits))
      for (const key of keys) {
        if (DEFAULT_TEXT_LIMITS[key] !== payload.limits[key]) {
          console.warn(`message limit drift: ${key} local=${DEFAULT_TEXT_LIMITS[key]} server=${payload.limits[key]}`)
        }
      }
      state.messageLimits = payload.limits
    }
    if (payload.labels) {
      state.messageLimitLabels = payload.labels
    }
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
